export enum FormId {
  SIGNUP = 'sign-up',
  WEBINAR = 'webinar',
  RESOURCE = 'resource',
  DATA_CONSULT = 'data-consult',
  PRISM = 'prism',
  STARTUP = 'startup',
}
